import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { adminFileRequester, adminRequester, requester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import SimpleTable from "routes/admin/table/SimpleTable";
import P from "components/P";

const OpenImageModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const modal = useRef();
  const clickOutsideToClose = true;
  const buttonText = t("close");
  const { src } = props;

  useEffect(() => {
    return () => {
      if (props.onClose) {
        props.onClose();
      }
    };
  }, []);

  const onDownload = () => {
    const splits = src.split("/");
    const name = splits.length > 0 ? splits[splits?.length - 1] : undefined;
    adminFileRequester.download(src, name);
  };
  return (
    <ModalBase
      borderRadius={"10px"}
      ref={modal}
      width={width}
      height={height}
      clickOutsideToClose={clickOutsideToClose}
      buttonText={buttonText}
    >
      <FlexChild>
        <img
          style={{ width: "100%" }}
          onClick={onDownload}
          src={src}
          alt="empty"
        />
      </FlexChild>
    </ModalBase>
  );
});

export default OpenImageModal;
